<template>
    <div v-if="selectedBiz.tax_id ==='0107544000094'" style="padding: 0% 2.4% 1% 2.7%;">
        <v-row no-gutters class="standard-row d-flex" style="padding: 0% 2.4% 1% 2.7%; justify-content: space-between;">
            <v-btn class="font-theme font-header-tabs-eval" height="52" depressed rounded text :to="'/eval_vendor'">&lt; กลับหน้ากล่องเอกสาร</v-btn>
            <v-btn class="blue-btn mb-1 font-theme" @click="downloadReport">Download</v-btn>
        </v-row>
        <v-card class="background-dashboard-summary-card">
            <v-card-title class="font-theme d-flex align-center pa-0" style="border-bottom: none;">
                <v-divider style="flex-grow: 1; height: 1px; background-color: #BCB9B9;"></v-divider>
                <span
                    style="font-weight: 600; font-size: calc(100% + 1.4vw); margin:16px; line-height: 45px;"
                    class="text-center font-theme">
                    สรุปผลการประเมิน
                </span>
                <v-divider style="flex-grow: 1; height: 1px; background-color: #BCB9B9;"></v-divider>
            </v-card-title>
            <v-row no-gutters class="standard-row font-theme" style="padding: 0% 1.2% 3.8% 1.2%;">
                <v-data-table :headers="headers" :items="summary_dashboard" fixed-header class="elevation-0 summary-table"
                    style="width: 100%;" hide-default-footer mobile-breakpoint="850">
                    <template v-slot:[`item.vendor_name`]="{ item }" >
                        <div style="text-align: left;">{{ item.vendor_name }}</div>               
                    </template>
                    <template slot=no-data>
                        <a class="text-center d-flex justify-center black--text" style="font-size: 16px;">
                            ไม่พบข้อมูล
                        </a>
                    </template>
                </v-data-table>
            </v-row>
        </v-card> 
        </div>
</template>
<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
export default {
    data: () => ({
        headers: [
            { text: "ชื่อบริษัทผู้ขาย (Vendor)", value: "vendor_name", align: "center", sortable: false, width: 200 },
            { text: "คะแนนรวม", value: "eval_vendor_scores_total", align: "center", sortable: false, width: 100 },
            { text: "จำนวนครั้ง", value: "count_vendor", align: "center", sortable: false, width: 100 },
            { text: "คะแนนเฉลี่ย", value: "score_average", align: "center", sortable: false, width: 100 },
            { text: "เกรด", value: "grade", align: "center", sortable: false, width: 100 },
        ],
        summary_dashboard: [],
        callApiPending: 0,
    }),
    mounted() {
        this.onResize()
        this.getTransaction()
    },
    computed: {
        selectedBiz () {
            return this.$store.state.confirmSelectedBiz
        },
    },
    watch: {
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {

                EventBus.$emit('loadingState', false)
            }
        },
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        async getTransaction() {
            try {
                this.callApiPending++;
                const response = await this.axios({
                    baseURL: this.$api_url,
                    url: `/saler_score/api/v1/summary_dashboard`,
                    method: 'GET'
                });
                this.summary_dashboard = response.data.data || [];
            } catch (error) {
                console.error(error);
                this.summary_dashboard = [];
            } finally {
                this.callApiPending--;
                if (!this.callApiPending) this.isReady = true;
            }
        },
        async downloadReport() {
            try {
                    this.callApiPending++;
                    var response = await this.axios.get(`${this.$api_url}/saler_score/api/v1/report_summary`, { responseType: "blob" });
                    if (response.data) {
                        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `SummaryEvalVendor-Report.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);

                        this.alert("ดาวน์โหลดรายงานสำเร็จ", "Success", "success");
                    } else {
                        this.alert("ดาวน์โหลดรายงานไม่สำเร็จ", "Fail", "error");
                    }
                } catch (error) {
                    console.log(error);
                    this.alert("ดาวน์โหลดรายงานไม่สำเร็จ", "Fail", "error");
                } finally {
                    this.callApiPending--;
            }
        },
        alert(title = '', text = 'Warning', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        
    }
}
</script>
<style>
.background-dashboard-summary-card {
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    margin: 0% 2.4% 1% 2.7% !important;
    border-radius: 23px !important;
}

.summary-table .v-data-table>.v-data-table__wrapper>table>tbody>tr:hover {
    cursor: pointer;
}

.summary-table .v-data-table__wrapper table .v-data-table-header tr th {
    background-color: #0B68D6;
    color: #F7F6F6 !important;
    box-shadow: none;
    border-right: 1px solid #F7F6F6;
    border-top: 1px solid #070707 !important;
    border-bottom: 1px solid #070707 !important;
}

.summary-table .v-data-table__wrapper table tbody tr td {
    font-size: 13px;
    border-bottom: 1px solid #070707 !important;
    border-right: 1px solid #070707 !important;
}

.summary-table thead th:first-child {
    border-radius: 0;
    border-left: 1px solid #070707 !important;
}

.summary-table td:first-child {
    border-left: 1px solid #070707 !important;
}

.summary-table thead th:last-child {
    border-radius: 0;
    border-right: 1px solid #070707 !important;
}

.summary-table .v-data-table__wrapper table thead tr th {
    font-size: 15px;
}


.summary-table .v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.summary-table .v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

.summary-table .v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #F7F6F6;
    ;
}

.summary-table .v-data-table__wrapper {
    max-height: calc(100vh - 305px);
    height: 100%;
    overflow-y: auto;
}
.font-header-tabs-eval{
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #060606 !important;
}

@media only screen and (max-width: 849px) {

.summary-table tbody tr td:first-child {
    border-top: 1px solid #070707 !important;
    border-left: 1px solid #070707 !important;
}

.summary-table tbody tr td {
    border-left: 1px solid #070707 !important;
}

.summary-table tbody tr td:last-child {
    border-right: 1px solid #070707 !important;
}

}
</style>